"use client";

import { Button } from "@/components/ui/button";
import { useSidebar } from "@/stores/sidebar.atoms";

export function SignupSidebarButton() {
    const [, setSidebar] = useSidebar();

    return (
        <Button onClick={() => setSidebar({ open: true, type: "signup" })} className="w-full">
            Sign Up
        </Button>
    );
}
